import React from 'react';
import {useSelector} from 'react-redux';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent.typed';
import {selectConsumerMobile} from '@/state/selectors/consumer';

import AutoDeliveryDcxSection from './AutoDeliveryDcxSection';

interface AutoDeliveryDcxMobileNumberProps {
    className?: string;
}

const AutoDeliveryDcxMobileNumber = ({className}: AutoDeliveryDcxMobileNumberProps) => {
    const mobile = useSelector(selectConsumerMobile);
    const {mobileNumberTitle, mobileNumberIcon} = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};

    if (!mobile) return null;

    return (
        <AutoDeliveryDcxSection className={className} title={mobileNumberTitle}>
            <div className='mt-4 flex items-center gap-2'>
                <RemoteIconV2 icon={mobileNumberIcon} className='shrink-0' />
                <span className='text-16 leading-155 tracking-02'>{mobile}</span>
            </div>
        </AutoDeliveryDcxSection>
    );
};

export default AutoDeliveryDcxMobileNumber;
